module.exports = __webpack_public_path__ + "images/473427153838dc27c8457762e8f13732c.svg";